// import IconButton from '@frontend/Components/Inputs/IconButton';
// import { faUpload } from '@fortawesome/free-solid-svg-icons';
// import SearchBar from '@frontend/Components/Inputs/SearchBar';
import UnifiedTopBar from '@frontend/Components/TopBar/UnifiedTopBar';
import { createListViewTemplate } from '@frontend/Components/TopBar/templates/listViewTemplate';

interface TopBarProps {
  onSearch: (searchTerm: string, column?: string | null) => void;
}

const TopBar = ({ onSearch }: TopBarProps) => {
  const columnsObject = {
    Subject: 'subject',
    Description: 'description',
  };

  // TODO: figure out the button icon.
  // const columnsArray = ['Subject', 'Description'];
  const notificationsTopBarConfig = createListViewTemplate({
    search: {
      columns: columnsObject,
      defaultSelectedColumn: 'Subject',
      onSearch: onSearch
    }
  });

  return <UnifiedTopBar {...notificationsTopBarConfig} />;
  // Legacy fallback
  // return (
  //   <div className="notificationrightSidetopBar">
  //     <IconButton icon={faUpload} ariaLabel="User" />
  //     <SearchBar
  //       onSearch={onSearch}
  //       columns={columnsArray}
  //       defaultSelectedColumn="Subject"
  //       style={{ width: '25vw' }}
  //     />
  //   </div>
  // );
};

export default TopBar;
